@if (state$ | async; as state) {
  <div class="page-header">
    <!-- the two Raporty tabs share one od–do: the links keep ?from&to, so the period is picked once (0118) -->
    <div class="page-title-group">
      <div class="page-title">Raporty</div>
      <nav class="report-tabs">
        <a class="report-tab" routerLink="/reports" queryParamsHandling="preserve">Zgłoszenia</a>
        <a class="report-tab selected" routerLink="/reports/materials" queryParamsHandling="preserve">Zapotrzebowanie materiałowe</a>
      </nav>
    </div>

    <!-- the log's toolbar, word for word -->
    <div class="header-toolbar">
      <label class="range-field">
        <span class="range-label">od</span>
        <input #fromInput class="field-input" type="date" [value]="state.from" (change)="onFromChange(fromInput.value)">
      </label>

      <label class="range-field">
        <span class="range-label">do</span>
        <input #toInput class="field-input" type="date" [value]="state.to" [min]="state.from" (change)="onToChange(toInput.value)">
      </label>

      <label class="range-field">
        <span class="range-label">Format</span>
        <select #formatSelect class="field-input" [value]="state.format" (change)="onFormatChange(formatSelect.value)">
          <option value="xlsx">Arkusz Excel</option>
          <option value="csv">CSV</option>
        </select>
      </label>

      <button class="btn" type="button" [disabled]="state.loading || !state.requirements?.rows?.length" (click)="export()">Eksportuj</button>
    </div>
  </div>

  @if (state.loading && !state.requirements) {
    Ładowanie…
  } @else if (state.requirements; as requirements) {
    <div class="list-panel">
      <div class="list-count">
        {{ rowCountLabel(requirements.rows.length) }}
        <span class="material-count-orders" [title]="orderNumbers(requirements)">{{ orderCountLabel(requirements.orders.length) }}</span>
      </div>

      <div class="list-table">
        <div class="list-row list-row-header material-row">
          <div class="list-cell">Zlecenie</div>
          <div class="list-cell">Pozycja</div>
          <div class="list-cell">Do</div>
          <div class="list-cell">Produkt końcowy</div>
          <div class="list-cell">Typ</div>
          <div class="list-cell">Struktura</div>
          <div class="list-cell list-cell-right">Ilość</div>
          <div class="list-cell">Jedn.</div>
        </div>

        <!-- Zgłoszenia's table for planned amounts (0122): one row per snapshot line, each zlecenie's
             trees laid flat, nothing summed — the reader filters and pivots in the file. Nazwa
             zlecenia is the number's tooltip here and a column of its own only in the file -->
        @for (row of requirements.rows; track row.orderItemId) {
          <div class="list-row material-row">
            <a class="list-cell material-row-order text-mono" [routerLink]="['/orders', row.orderId]" [title]="row.orderName">{{ row.orderNumber }}</a>
            <div class="list-cell material-row-name" [title]="row.name">{{ row.name }}</div>
            <div class="list-cell material-row-parent" [title]="parentLabel(row)">{{ parentLabel(row) }}</div>
            <div class="list-cell material-row-root" [title]="row.rootName">{{ row.rootName }}</div>
            <div class="list-cell material-row-type">{{ rowTypeLabels[row.type] }}</div>
            <div class="list-cell material-row-structure">{{ structureLabels[row.structure] }}</div>
            <div class="list-cell list-cell-right material-row-amount text-mono">{{ formatNumber(row.amount) }}</div>
            <div class="list-cell material-row-unit">{{ row.unit }}</div>
          </div>
        } @empty {
          <!-- a counted zlecenie always has at least its root's row, so no rows means no zlecenia -->
          <div class="list-empty">Brak zaplanowanych zleceń w tym okresie</div>
        }
      </div>
    </div>
  }
}
